module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-24.0cc401ed.png";